document.addEventListener("DOMContentLoaded", function () {
  async function getFetchedContent() {
    const element = document.querySelector('.complementary-products');
    const dataUrl = element.getAttribute('data-url');
    const url = dataUrl;
    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Accept": "text/html",
        }
      });

      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const complementaryProducts = doc.querySelector(".complementary-products");

      const targetDiv = document.querySelector(".complementary-products"); 
      if (targetDiv && complementaryProducts) {
        targetDiv.innerHTML = complementaryProducts.innerHTML;
        console.warn("Target div or fetched content found!");
      } else {
        console.warn("Target div or fetched content not found!");
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('collection:slider:init'));
        // console.log("This message appears after 2 seconds");
      }, 200);
      return complementaryProducts ? complementaryProducts.innerHTML : null;
    } catch (error) {
      console.error("Error fetching content:", error);
      return null;
    }
  }
  document.addEventListener('click', function(e) {
  if (e.target.matches('.cpm-addtocart')) {
    e.preventDefault();

    const button = e.target;
    const form = button.closest('form');
    let variantId;
    if (form){
      var loader = form.querySelector('.loader');
      if (loader){
        loader.classList.add('active');
      }
    }
    if (form) {
      variantId = new FormData(form).get('id');
    } else {
      variantId = button.dataset.variantId || button.getAttribute('data-variant-id');
    }

    if (!variantId) {
      console.error("Variant ID not found!");
      return;
    }
$.ajax({
    url: window.Shopify.routes.root + 'cart/add.js',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
        'items': [{"id": variantId, "quantity": 1}]
    }),
    dataType: 'json',
    success: function (resp) {
        setTimeout(function () {
         // console.log('fetch-content')
           getFetchedContent();
        },400)
        
        const cartForm = document.querySelector('cart-form');
        if (cartForm) {
            cartForm.refresh();
        }
        //cart notification on mobile
        var windowSize = window.innerWidth;
        if (windowSize < 750) {
            const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
            
            notification.dataset.productImage = resp.items[0].featured_image.url;
            notification.dataset.productTitle = resp.items[0].product_title;
            let notificationContainer = document.querySelector('.pageheader--sticky');
            if (!notificationContainer) {
            notificationContainer = document.querySelector('body');
            }
            notificationContainer.appendChild(notification);
        } else {
            document.querySelector('.js-cart-drawer').open();
        }
       

    },
    error: function (error) {
        console.error('Error:', error);
    }
});

  }
});

(function() {
  const originalFetch = window.fetch;

  window.fetch = function(url, options) {
    const isCartAdd = url.includes('/cart/add.js'); 
    const isCartChange = url.includes('/cart/change.js') || url.includes('/cart/update.js'); 
    
    return originalFetch.apply(this, arguments).then(response => {
      // Only run removal logic on change or update
      if (isCartChange) {
        response.clone().json().then(data => {
         getFetchedContent()
        });
      } else if (isCartAdd) {
        //console.log('Cart add detected - skipping upsell removal logic');
      }

      return response;
    });
  };
})();



});